<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded">I dedicate this book to my wife, Joanie, my office manager, Judy, and to my entire staff, including my technicians, Bev and Kelly, my veterinary assistant, Carol, my receptionists, Laura, Jan, and Michelle, and my kennel assistant, Annie, all of whom, by doing their jobs so well, provided me with the time, energy, and peace of mind to write this book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7a537107